import { useSelector } from 'react-redux';
import { departmentSettingsSelector } from 'store/user/user.selectors';

export const useDepartmentSettings = () => {
  return useSelector(departmentSettingsSelector);
};
